export default __webpack_public_path__ + "static/media/nfc.495e9d0a.png";